import styled from '@emotion/styled';
import { Stack, Typography, colors } from '@ui-components/neo.tax';

import { screenXl } from '@neo.tax/shared';

export const StyledStack = styled(Stack)<{ disabled: boolean }>(
  {
    overflowY: 'auto',
    height: 678,
    width: 360,
  },
  ({ disabled }) => ({
    filter: disabled ? 'blur(4px)' : 'none',
  }),
  screenXl({
    width: 340,
  }),
);

export const MonthAllocationsContainer = styled(Stack)({
  opacity: 0.5,
});

export const MonthAllocations = styled(Stack)({
  minHeight: 60,
});

export const OverallContainer = styled(Stack)({
  gap: 10,
});

export const Divider = styled.div({
  width: '100%',
  height: 1,
  backgroundColor: colors.gray[300],
});

export const AllocationBar = styled(Stack)<{ width: 'sm' | 'lg' }>(
  {
    height: 20,
    boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;',
  },
  ({ width }) => ({
    width: width === 'sm' ? 200 : 250,
  }),
);

export const StyledTypography = styled(Typography)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});
